import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import AppRateContainer from '../containers/AppRateContainer';
import { updateUser } from '../actions/userActions';
import { resetModal } from '../actions/modalsActions';
import { appRateStatuses } from '../utils/constants';
import i18n from '../utils/i18n';
import Modal from './Modal';

class AppRateModal extends React.Component {
  constructor(props) {
    super(props);
    this.close = this.close.bind(this);
    this.finish = this.finish.bind(this);
    this.close = this.close.bind(this);
    this.setItShouldFinishRating = this.setItShouldFinishRating.bind(this);
    this.chooseIfCloseOrFinish = this.chooseIfCloseOrFinish.bind(this);

    this.state = {
      itShouldFinishRating: false
    };
  }

  setItShouldFinishRating(value) {
    this.setState({ itShouldFinishRating: value });
  }

  finish() {
    this.props.updateUser({
      app_rating_status: appRateStatuses.VOTED
    });
    this.props.resetModal();
  }

  chooseIfCloseOrFinish() {
    if (this.state.itShouldFinishRating) {
      this.finish();
    } else {
      this.close();
    }
  }

  close() {
    this.props.updateUser({
      app_rating_status: appRateStatuses.DISMISSED
    });
    this.props.resetModal();
  }

  render() {
    return (
      <Modal
        isOpen={ true }
        showAnyButton={ false }
        onRequestClose={ this.chooseIfCloseOrFinish }
      >
        <div className="modal-container">
          <h1 className="modal-header">
            {i18n.t('modals.appRate.ENJOYING_DEUCE')}
          </h1>
          <AppRateContainer
            onClose={ this.close }
            onFinish={ this.finish }
            setItShouldFinishRating={ this.setItShouldFinishRating }
          />
        </div>
      </Modal>
    );
  }
}

AppRateModal.propTypes = {
  updateUser: PropTypes.func.isRequired,
  resetModal: PropTypes.func.isRequired
};

const mapDispatchToProps = dispatch => ({
  dispatch,
  updateUser: params => dispatch(updateUser(params)),
  resetModal: () => dispatch(resetModal())
});

export default connect(null, mapDispatchToProps)(AppRateModal);



// WEBPACK FOOTER //
// ./src/modals/AppRateModal.js